import type { App } from 'vue';
import { VueQueryPlugin, QueryClient, type VueQueryPluginOptions } from '@tanstack/vue-query';
import { VueQueryDevtools } from '@tanstack/vue-query-devtools';
import type { AxiosError } from 'axios';
import { QUERY_DEFAULTS } from '@/constants.ts';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: QUERY_DEFAULTS.staleTime,
      gcTime: QUERY_DEFAULTS.gcTime,
      retryDelay: QUERY_DEFAULTS.retryDelay,
      refetchOnWindowFocus: 'always',
      retry: (failureCount: number, error: unknown) => {
        if ((error as AxiosError<{ message?: string }>).response?.status === 401) {
          return false;
        }
        return failureCount < QUERY_DEFAULTS.retryAttempts;
      }
    },
    mutations: { retry: 0 }
  }
});

export function installVueQuery(app: App) {
  const options: VueQueryPluginOptions = { queryClient };
  app.use(VueQueryPlugin, options);

  // Mount devtools in dev only
  if (import.meta.env.DEV) {
    app.component('VueQueryDevtools', VueQueryDevtools);
  }

  return queryClient;
}

export { queryClient };
